import type { ColDef, ColGroupDef } from "@tokenterminal/ui/DataTable"

export type ColumnDef = ColDef<any, any> | ColGroupDef<any>

export function isColGroup(columnDef: ColumnDef): columnDef is ColGroupDef {
  return (
    (columnDef as ColGroupDef).children &&
    Array.isArray((columnDef as ColGroupDef).children)
  )
}
